import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./style.css";
import Captcha from "../Captcha";
import axios from "axios";


const AdminSignIn = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorUsername, setErrorUsername] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);
  const [error, setError] = useState([]);

  const handleCaptchaChange = (isCorrect) => {
    setIsCaptchaCorrect(isCorrect);
  };

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = [];
    
    if (!isCaptchaCorrect) {
      errors.push("Captcha answer is incorrect. Please try again.");
    }

    if (!username || !password) {
      errors.push("Username and password are required.");
    }

    if (username.length < 5) {
      errors.push("Username must be at least 5 characters.");
    }

    if (password.length < 8) {
      errors.push("Password must be at least 8 characters.");
    }

    if (errors.length === 0) {
      setError([]);

      try {
        const response = await axios.post("https://jacobjose.azurewebsites.net/auth/generateToken", {
          username,
          password,
        });

        if (response.status === 200) {
          setErrorUsername("");
          setErrorPassword("");
          localStorage.setItem("accountName", username);
          history.push("/dashboard");
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 400) {
            if (error.response.data === "Invalid username or password") {
              setError(["Invalid username or password"]);
            }
          } else {
            console.error("Error:", error);
            errors.push("An error occurred. Please try again later.");
            setError(errors);
            setShowErrorPopup(true);
          }
        }
      }
    } else {
      setError(errors);
      setShowErrorPopup(true);
    }
  };


  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  return (
    <div className="admin-sign-in-box">
      <div className="admin-sign-in-content">
        <h2>Admin Sign In</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="admin-username">Username:</label>
          <input
            type="text"
            id="admin-username"
            name="admin-username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <label htmlFor="admin-password">Password:</label>
          <input
            type="password"
            id="admin-password"
            name="admin-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <Captcha onCaptchaChange={handleCaptchaChange} />

          <button type="submit">Sign In</button>
        </form>

        <div className="admin-sign-in-links">
          <p>
            <a href="/ForgotPassword">Forgot Password?</a>
          </p>
          <p>
            New User? <Link to="/AdminSignUp">Create an Account</Link>
          </p>
        </div>
        {error.length > 0 && (
          <div className="error-message">
            <p>Please fix the following errors:</p>
            <ul>
              {error.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )}
        {showErrorPopup && (
          <div className="popup" onClick={closeErrorPopup}>
            <div className="popup-content">
              <span className="close" onClick={closeErrorPopup}>
                &times;
              </span>
              <p className="error-message">{errorUsername || errorPassword}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSignIn;
